export class RequestError extends Error {
  constructor(message: string, public status: number) { super(message); }
}
export async function request<T>(path: string, body?: unknown, signal?: AbortSignal): Promise<T> {
  const response = await fetch(path, { signal, ...(body === undefined ? {} : { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) }) });
  const data = await response.json() as T & { error?: string };
  if (!response.ok) throw new RequestError(data.error || 'That did not work. Please try again.', response.status);
  return data;
}
